module.exports = __webpack_public_path__ + "img/promo_icon.e0e1e70d.svg";